import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import { SelectedSection } from '../../../../types/courseSelectionTypes';
import { TranslationsKeys } from '../../../../locales/translations';

interface CreditCardsProps {
  creditMin: number;
  creditsContracted: number | null;
  selectedSections: SelectedSection[];
}

export default function CreditCards({
  creditMin,
  creditsContracted,
  selectedSections,
}: CreditCardsProps) {
  const { t } = useTranslation(TranslationsKeys.PETITIONS);

  const text = useMemo(() => {
    const prefix = 'creditReliquidation.creditCards';
    return {
      creditMin: t(`${prefix}.creditMin`),
      creditsContracted: t(`${prefix}.creditsContracted`),
      creditsSelected: t(`${prefix}.creditsSelected`),
    };
  }, [t]);

  const selectedCredits = useMemo(() => {
    return selectedSections.reduce(
      (sum, section) => sum + (section.course?.credits ?? 0),
      0,
    );
  }, [selectedSections]);

  const frozenCredits = useMemo(() => {
    if (creditsContracted === null) {
      return 0;
    }
    return Math.max(0, creditsContracted - selectedCredits);
  }, [creditsContracted, selectedCredits]);

  return (
    <Row className="mb-4">
      <Col md={4} className="mb-3">
        <div className="bg-white border rounded p-3 h-100">
          <p className="fs-12 text-uppercase text-light mb-1">
            {text.creditMin}
          </p>
          <p className="fs-24 fw-700 tc-primary mb-0">{creditMin}</p>
        </div>
      </Col>
      <Col md={4} className="mb-3">
        <div className="bg-white border rounded p-3 h-100">
          <p className="fs-12 text-uppercase text-light mb-1">
            {text.creditsContracted}
          </p>
          <p className="fs-24 fw-700 tc-primary mb-0">{frozenCredits}</p>
        </div>
      </Col>
      <Col md={4} className="mb-3">
        <div className="bg-white border rounded p-3 h-100">
          <p className="fs-12 text-uppercase text-light mb-1">
            {text.creditsSelected}
          </p>
          <p className="fs-24 fw-700 tc-primary mb-0">{selectedCredits}</p>
        </div>
      </Col>
    </Row>
  );
}
